import { Fragment, useEffect, useState } from 'react';
import { Container } from '@/components/container';
import {
    Toolbar,
    ToolbarActions,
    ToolbarDescription,
    ToolbarHeading,
    ToolbarPageTitle,
} from '@/partials/toolbar';
import { PageNavbar } from '@/pages/account';
import { UsersContent } from './UsersContent.tsx';
import { KeenIcon } from '@/components';
import axios from 'axios';
import { UserDetailsData } from '@/pages/buddy/types/UserDetailsData'; // Updated type
import { useParams } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';

const UsersPage = () => {
    const [users, setUsers] = useState<UserDetailsData[]>([]);
    const [newUserModalOpen, setNewUserModalOpen] = useState(false);
    const handleOpen = () => setNewUserModalOpen(true);
    const handleClose = () => setNewUserModalOpen(false);
    const { tab } = useParams<{ tab?: string }>();
    const [activePage, setActivePage] = useState<string>(tab || 'overview');

    const [loading, setLoading] = useState(true);

    // Update your actual API endpoints here
    const API_USERS = `${import.meta.env.VITE_APP_API_URL}/admin/users`;
    const API_USER = `${import.meta.env.VITE_APP_API_URL}/admin/user`;

    const fetchUserData = async () => {
        setLoading(true);
        try {
            const response = await axios.get<UserDetailsData[]>(API_USERS, {
                headers: {
                    Accept: 'application/json',
                },
            });

            setUsers(response.data);

            if (response.data.length === 0) {
                handleOpen();
            }

        } catch (err) {
            enqueueSnackbar(`Failed to fetch users data: ${err}`, {
                variant: 'solid',
                state: 'danger',
            });
        } finally {
            setLoading(false);
        }
    };

    const handleConfirmDeleteUser = async (userId: string) => {
        try {
            await axios.delete(`${API_USER}/${userId}`, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            fetchUserData();
            enqueueSnackbar('The user has been successfully deleted.', {
                variant: 'solid',
                state: 'success',
            });
        } catch (err) {
            enqueueSnackbar(`Failed to delete the user: ${err}`, {
                variant: 'solid',
                state: 'danger',
            });
        }
    };

    useEffect(() => {
        fetchUserData();
    }, []);

    return (
        <Fragment>
            <PageNavbar />

            {/* <NewUserModal open={newUserModalOpen} onClose={handleClose} /> */}

            <Container>
                <Toolbar>
                    <ToolbarHeading>
                        <ToolbarPageTitle />
                        <ToolbarDescription>
                            View all users to manage roles, permissions, and access within your organization.
                        </ToolbarDescription>
                    </ToolbarHeading>
                    <ToolbarActions>
                        <button onClick={handleOpen} type="button" className="btn btn-sm btn-primary">
                            <KeenIcon icon="plus" /> Add New User
                        </button>
                    </ToolbarActions>
                </Toolbar>
            </Container>

            <Container>
                <UsersContent
                    users={users}
                    loading={loading}
                />
            </Container>
        </Fragment>
    );
};

export { UsersPage };
